/* eslint-disable no-template-curly-in-string */
import * as YupCore from "yup";

//todo: futuramente colocar i18n
const translate = {
  mixed: {
    default: "Campo inválido.",
    required: "Campo obrigatório.",
    notType: "Campo inválido.",
    oneOf: "Este campo não corresponde. ",
    max: "Esse campo deve ser menor que ${max}.",
    min: "Esse campo deve ser maior que ${min}.",
  },
  string: {
    length: "Esse campo deve ter exatamente ${length} caracteres",
    email: "Esse campo precisa ser um email válido",
    max: "Esse campo deve ser menor que ${max} caractéres.",
    min: "Esse campo deve ser maior que ${min} caractéres.",
  },
  number: {
    max: "Esse campo deve ser menor que ${max}.",
    min: "Esse campo deve ser maior que ${min}.",
  },
  array: {
    max: "Esse campo deve ser menor que ${max}.",
    min: "Selecione pelo menos ${min} para continuar.",
  },
};

YupCore.setLocale(translate);

export { YupCore };
